<template>
  <div>
    <v-subheader class="zoox-component zoox-section-divider">
      <b class="body-bold mr-2">{{ title }}</b>
      <v-divider></v-divider>
      <z-icon
        v-if="$scopedSlots.content"
        class="ml-2"
        :icon-up="iconUp"
        :icon-down="iconDown"
        @click="isOpen = !isOpen"
      >
        {{ isOpen ? iconUp : iconDown }}
      </z-icon>
    </v-subheader>
    <v-expand-transition>
      <div v-show="isOpen">
        <!--@slot Slot genérico que define o conteúdo do componente -->
        <slot name="content"></slot>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
/**
 * @displayName Section Divider
 */
export default {
  name: 'ZSectionDivider',
  props: {
    /**
     * Define o titulo do divider
     */
    title: {
      type: String,
      required: false,
    },
    /**
     * Prop para indicar que o accordion deve iniciar aberto
     */
    startOpened: {
      type: Boolean,
      required: false,
    },
    /**
     * Prop para escolher o icone que mostrar o conteúdo do v-subheader
     */
    iconDown: {
      type: String,
      default: '$keyboard_arrow_down_rounded',
    },
    /**
     * Prop para escolher o icone que vai esconder o conteúdo do v-subheader
     */
    iconUp: {
      type: String,
      default: '$keyboard_arrow_up_rounded',
    },
  },
  data(vm) {
    return {
      isOpen: vm.startOpened ? true : false,
    }
  },
  methods: {
    /**
     * @public
     *
     * Método exposto para abrir o accordion
     */
    open() {
      this.isOpen = true
    },
    /**
     * @public
     *
     * Método exposto para fechar o accordion
     */
    close() {
      this.isOpen = false
    },
  },
}
</script>

<style scoped></style>
